module.exports = __webpack_public_path__ + "static/media/portlinkLogo.aa0ce266.svg";